var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m280.62 54.943-145.214 101.05-2.931 7.728h-28.809v183.279h29.283l2.457 9.007 145.214 101.05c7.994 5.563 18.943-.158 18.943-9.896v-191.161-191.161c.001-9.738-10.949-15.459-18.943-9.896z",
    fill: "#b6c4cf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342.923 213.252c-4.281 5.284-3.989 12.461.523 17.578 6.161 6.987 9.862 15.833 9.907 25.472s-3.572 18.52-9.667 25.563c-4.464 5.159-4.688 12.338-.358 17.582 6.18 7.484 18.582 7.762 25.007.439 10.546-12.019 16.825-27.231 16.747-43.733s-6.499-31.654-17.157-43.575c-6.494-7.261-18.892-6.867-25.002.674z",
    fill: "#f79595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m381.084 166.327-.008.01c-4.763 5.879-3.823 13.974 1.997 19.004 20.665 17.856 33.607 42.988 33.738 70.844s-12.575 53.108-33.071 71.155c-5.773 5.083-6.637 13.187-1.819 19.021l.009.01c5.723 6.931 16.877 7.724 23.746 1.695 26.562-23.315 43.034-55.985 42.865-92.029s-16.948-68.559-43.728-91.626c-6.925-5.964-18.071-5.068-23.729 1.916z",
    fill: "#fd8087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.82 119.925-.012.015c-4.853 5.991-3.88 14.362 2.299 19.24 36.048 28.458 58.943 70.263 59.162 116.887s-22.282 88.641-58.061 117.434c-6.133 4.936-7.027 13.316-2.118 19.261l.012.014c5.541 6.71 16.262 7.736 23.183 2.164 42.345-34.091 68.973-83.83 68.714-139.02-.259-55.191-27.354-104.679-70.017-138.374-6.973-5.508-17.684-4.382-23.162 2.379z",
    fill: "#fe646f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.62 417.372-145.214-101.05v39.685l145.214 101.05c7.994 5.563 18.943-.158 18.943-9.896v-39.685c.001 9.738-10.949 15.459-18.943 9.896z",
    fill: "#9facba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.407 356.007h-104.801c-16.903 0-30.606-13.703-30.606-30.606v-138.802c0-16.903 13.703-30.606 30.606-30.606h104.801z",
    fill: "#596c76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 285.716v39.685c0 16.903 13.703 30.606 30.606 30.606h104.801v-39.685h-104.801c-16.903 0-30.606-13.703-30.606-30.606z",
    fill: "#465a61"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.17ad5f17.svg";
export { ForwardRef as ReactComponent };